import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  onClick: () => void;
}
const AddressCancelBtn: React.FC<Props> = ({ onClick }) => {
  const t = useTranslation();
  return (
    <CustomButton
      type={BtnTypes.secondary}
      size={BtnSizes.large}
      radius={BtnRadius.small}
      onClick={onClick}
      fullWidth
    >
      {t.cancel}
    </CustomButton>
  );
};

export default AddressCancelBtn;
